import React, { useEffect } from 'react';
import { useRouteError } from 'react-router-dom';
import ErrorPage from '@lib/components/ErrorPage/ErrorPage';
import { ErrorPageStatusEnum } from '@lib/components/ErrorPage/enums';
import { captureException } from '@lib/utils/captureException';

/**
 * Router-level `errorElement` for errors thrown outside a layout's
 * `ErrorBoundary` (route guards, layouts, lazy-chunk loading).
 * Error details are rendered in dev only.
 */
export default function RouteErrorElement() {
  const error = useRouteError();

  useEffect(() => {
    captureException(error);
  }, [error]);

  return (
    <>
      <ErrorPage status={ErrorPageStatusEnum.Status500} fullHeight />
      {import.meta.env.DEV && error instanceof Error && (
        <pre style={{ padding: 16, whiteSpace: 'pre-wrap' }}>
          {error.stack || error.message}
        </pre>
      )}
    </>
  );
}
